import {IMasterDataUsageService} from "../PA.MD.Core/PA.MD.IF.Usage";
import {UIClipboardService} from "../PA.UIFramework.Services/UIFrameworkService";
import * as _ from "lodash"
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";

export class MDUsageService
    implements IMasterDataUsageService
{
    static cbs: UIClipboardService = undefined

    constructor() { }


    private static getClipboardService(): UIClipboardService {
        if(_.isEmpty(MDUsageService.cbs))
            MDUsageService.cbs = new UIClipboardService()

        return MDUsageService.cbs
    }


    private static getCurrentUserId(): number {
        let uc: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        if(_.isEmpty(uc))
            return 0
        return uc.User?.cif?.WB_AUTHUSR_ID || 0
    }


    async saveCompanyUsage(wbCompanyId: number): Promise<void> {
        let cbs = MDUsageService.getClipboardService()
        let wbUserId = MDUsageService.getCurrentUserId()
        await cbs.SaveClipboardEntry({Usage: "Company", SubUsage: "LRU", Clip: {wbCompanyId: wbCompanyId}})
    }


    async getCompanyUsage(): Promise<number> {
        let cbs = MDUsageService.getClipboardService()
        let wbUserId = MDUsageService.getCurrentUserId()
        let a = await cbs.FindClipboardEntry({usage: "Company", subUsage: "LRU", wbUserId: wbUserId, count: 1})

        if (a.length)
            return a[0].Clip?.wbCompanyId

        return undefined
    }


    async getSalesAreaUsage(): Promise<number> {
        let cbs = MDUsageService.getClipboardService()
        let wbUserId = MDUsageService.getCurrentUserId()
        let a = await cbs.FindClipboardEntry({usage: "SalesArea", subUsage: "LRU", wbUserId: wbUserId, count: 1})

        if (a.length)
            return a[0].Clip?.wbSalesAreaId
        return undefined
    }


    async getSalesOrgUsage(): Promise<number> {
        let cbs = MDUsageService.getClipboardService()
        let wbUserId = MDUsageService.getCurrentUserId()
        let a = await cbs.FindClipboardEntry({usage: "SalesOrg", subUsage: "LRU", wbUserId: wbUserId, count: 1})

        if (a.length)
            return a[0].Clip?.wbSalesOrgId
        return undefined
    }


    async saveSalesAreaUsage(wbSalesAreaId: number): Promise<void> {
        let cbs = MDUsageService.getClipboardService()
        await cbs.SaveClipboardEntry({Usage: "SalesArea", SubUsage: "LRU", Clip: {wbSalesAreaId: wbSalesAreaId}})
    }


    async saveSalesOrgUsage(wbSalesOrgId: number): Promise<void> {
        let cbs = MDUsageService.getClipboardService()
        await cbs.SaveClipboardEntry({Usage: "SalesOrg", SubUsage: "LRU", Clip: {wbSalesOrgId: wbSalesOrgId}})
    }


    async getMDSetUsage(): Promise<number> {
        let cbs = MDUsageService.getClipboardService()
        let wbUserId = MDUsageService.getCurrentUserId()
        let a = await cbs.FindClipboardEntry({usage: "MDSet", subUsage: "LRU", wbUserId: wbUserId, count: 1})

        if (a.length)
            return a[0].Clip?.wbMDSetId
        return undefined
    }


    async saveMDSetUsage(wbMDSetId: number): Promise<void> {
        let cbs = MDUsageService.getClipboardService()
        await cbs.SaveClipboardEntry({Usage: "MDSet", SubUsage: "LRU", Clip: {wbMDSetId: wbMDSetId}})
    }


}